const memberApiUrl =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'
    ? 'https://se-elle-member-api-stage.aws.aller.com'
    : 'https://se-elle-member-api.aws.aller.com';

const fetchWrapper = async function (url, method = 'GET', data, jwt) {
  const body = data && JSON.stringify(data);
  const response = await fetch(url, {
    method,
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
    referrerPolicy: 'no-referrer',
    body,
  });
  return response.json();
};

export const fetchFavoriteArticleIds = async (jwt) => {
  return fetchWrapper(`${memberApiUrl}/article`, 'GET', null, jwt);
};

export const isMember = async (jwt) => {
  return fetchWrapper(`${memberApiUrl}/member`, 'GET', null, jwt);
};

export const addMember = async (jwt) => {
  return fetchWrapper(`${memberApiUrl}/member`, 'POST', null, jwt);
};

export const addFavoriteArticle = async (articleId, jwt) => {
  return fetchWrapper(`${memberApiUrl}/article`, 'POST', { articleId }, jwt);
};

export const removeFavoriteArticle = async function (articleId, jwt) {
  return fetchWrapper(`${memberApiUrl}/article/${articleId}`, 'DELETE', null, jwt);
};
